/**
 * Created by KELLY-PC on 14/01/2019.
 */
/* eslint-disable */
import grafico from '../js/graficos'

export default {
  grafico(){
    return grafico
  },
// VALIDAR CAMPOS
  validaCampo(campo) {
    if (campo !== undefined && campo !== null && campo !== '') {
      return true
    } else {
      return false
    }
  },

// COMPARAR VALORES
  retorno(item, str, retorno1, retorno2) {
    if (typeof str === 'boolean') {
      if (item === str) {
        return retorno1
      } else {
        return retorno2
      }
    } else {
      if (item.toLowerCase() === str.toLowerCase()) {
        return retorno1
      } else {
        return retorno2
      }
    }


  },

// VERIFICAR SE É NUMERO
  IsNumeric(str) {
    str = str.replace(',', '.')
    return !!str.match(/^-?\d*\.?\d+$/)
  },

// VERIFICAR SE É LETRA
  IsLetter(str) {
    return !!str.match(/^[a-zA-Z]/)
  },

// VERIFICAR SE O NUMERO É INTEIRO
  IsInteiro(str) {
    return !!str.match(/^\d+$/)
  },


  voltarTelaAnterior(caminho, tempo) {
    setInterval(function () {
      window.location = caminho
    }, tempo)
  },

  desabilitarAdicionar(lista) {
    if (lista.length <= 0) {
      return false
    } else {
      return true
    }
  },


// ADICIONAR MASCARAS
  maskDecimal(v) {
    v = v.toString()
    if (v !== null) {
      v = v.replace(/\D/g, '')
      v = v.replace(/(\d{2})$/, '0,$1')
      v = v.replace(/(\d+)(\d{3},\d{2})$/g, '$1.$2')
      var qtdLoop = (v.length - 3) / 3
      var count = 0
      while (qtdLoop > count) {
        count++
        v = v.replace(/(\d+)(\d{3}.*)/, '$1.$2')
      }
      v = v.replace(/^(0)(\d)/g, '$2')
    }
    return v
  },

  maskCpf (cpf) {
    // eslint-disable-next-line no-useless-escape,no-useless-escape, no-useless-escape, no-useless-escape
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4')
  },

  maskCep (cpf) {
    // eslint-disable-next-line no-useless-escape,no-useless-escape, no-useless-escape, no-useless-escape
    return cpf.replace(/(\d{2})(\d{3})(\d{3})/g, '\$1.\$2\-\$3')
  },

  maskTel (cpf) {
    // eslint-disable-next-line no-useless-escape,no-useless-escape, no-useless-escape, no-useless-escape
    return cpf.replace(/(\d{2,3})(\d{4,5})(\d{4})/g, '(\$1)\$2\-\$3')
  },

  maskCnpj (cnpj) {
    // eslint-disable-next-line no-useless-escape,no-useless-escape, no-useless-escape, , no-useless-escape, no-useless-escape
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5')
  },

  TestaCPF (strCPF) {
    var CPF = require('cpf_cnpj').CPF
    var CNPJ = require('cpf_cnpj').CNPJ
    var isValido
    if (this.validaCampo(strCPF)) {
      strCPF = strCPF.replace(/[^0-9]+/g, '')

      if (strCPF.length === 11) {
        isValido = CPF.isValid(strCPF)
      } else if (strCPF.length >= 12 && strCPF.length <= 14) {
        isValido = CNPJ.isValid(strCPF)
      } else {
        isValido = false
      }
    }
    return isValido
  },

  // REMOVER MASCARAS */
  removerMascara (str) {
    if (this.validaCampo(str)) {
      return str.replace(/[^0-9]+/g, '')
    } else {
      return ''
    }
  },

  removeMascaraMonetaria (v) {
    var a
    var b
    if (v.length >= 10) {
      a = v.replace('.', '')
      a = a.replace('.', '')
      b = a.replace(',', '.')
    } else {
      a = v.replace('.', '')
      b = a.replace(',', '.')
    }
    return b
  },

  // FORMATAR CAMPOS
  formatMonetarioBR(v) {
    v = v.toString()

    if (v !== null) {
      v = v.replace(/\D/g, '')
      v = v.replace(/(\d{2})$/, ',$1')
      v = v.replace(/(\d+)(\d{3},\d{2})$/g, '$1.$2')
      var qtdLoop = (v.length - 3) / 3
      var count = 0
      while (qtdLoop > count) {
        count++
        v = v.replace(/(\d+)(\d{3}.*)/, '$1.$2')
      }
      v = v.replace(/^(0)(\d)/g, '$2')
    }

    return v
  },

  /* Formatação dos marcadores */

  toUppercase(str) {
    str = str.replace(/\s/g, '').toUpperCase()
    if (str.length !== 3) return false
    return str
  },

  formatName(str) {
    let words = str.split(' ').filter(str => str !== '')
    words = words.map(str => str.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
    words = words.map(str => str[0].toUpperCase() + str.slice(1))
    return words.join(' ')
  },

  LetraMaiuscula(text) {
    text = text.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase()
    })
    return text
  },

  paraDecimal(v) {
    var decimal = v.replace(',', '.')
    return decimal
  },

  maskData(data) {
    return data.replace(/^(\d{1,2})(\d{1,2})(\d{4})$/, '$1/$2/$3')
  },

  inverterData(data, rem, add) {
    var newData = data.split(rem)
    return newData.reverse().join(add)
  },

  dataSql(data) {
    data = this.maskData(data)
    data = this.inverterData(data, '/', '-')
    return data
  },

  IsCEP(strCEP) {
    var aux = strCEP.replace(/^([0-9]{2})([0-9]{3})([0-9]{3})$/, '$1.$2-$3')
    return aux
  },

  // Chips
  dropDownShow() {
    var openDropdown = document.getElementById('myDropdown')
    if (openDropdown.classList.contains('close')) {
      openDropdown.classList.remove('close')
    }
    openDropdown.classList.toggle('show')
  },

  dropDownClose() {
    var openDropdown = document.getElementById('myDropdown')
    if (openDropdown.classList.contains('show')) {
      openDropdown.classList.remove('show')
    }
    openDropdown.classList.toggle('close')
  },

  /*   ORDENAR    */
  ordenarLista(lista) {
    lista = lista.sort(function (a, b) {
      return a.descricao < b.descricao ? -1 : a.descricao > b.descricao ? 1 : 0
    })
    return lista
  },

  /*  ADCIONAR E REMOVER CLASSE CSS */
  addClassById(id, classe) {
    var elemento = document.getElementById(id)
    var classes = elemento.className.split(' ')
    var getIndex = classes.indexOf(classe)
    if (getIndex === -1) {
      classes.push(classe)
      elemento.className = classes.join(' ')
    }
  },

  delClassById(id, classe) {
    var elemento = document.getElementById(id)
    var classes = elemento.className.split(' ')
    var getIndex = classes.indexOf(classe);

    if (getIndex > -1) {
      classes.splice(getIndex, 1)
    }
    elemento.className = classes.join(' ')
  },

  addClassByClasse(classe, novaClasse) {
    var elemento = document.getElementsByClassName(classe)
    var classes = elemento.className.split(' ')
    var getIndex = classes.indexOf(novaClasse)
    if (getIndex === -1) {
      classes.push(novaClasse)
      elemento.className = classes.join(' ')
    }
  },

  delClassByClasse(classe, novaClasse) {
    var elemento = document.getElementsByClassName(classe)
    var classes = elemento.className.split(' ')
    var getIndex = classes.indexOf(novaClasse);

    if (getIndex > -1) {
      classes.splice(getIndex, 1)
    }
    elemento.className = classes.join(' ')
  },

  alterarBackgroundTabela(classe, cor) {
    var elemento = document.getElementsByClassName(classe)
    if (this.validaCampo(elemento)) {
      for (var i = 0; i <= elemento.length; i++) {
        if (this.validaCampo(elemento[i])) {
          if (elemento[i].className === classe) {
            elemento[i].style.background = cor
          }
        }

      }
    }
  },

  /* STRNGS  */
  cortarString(str, tam) {
    return str.slice(0, tam);
  },
  focusInput(id) {
    var loadTime = 10
    window.onload = function () {
      loadTime = window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart;
    }
    var interval = setInterval(function () {
      var muniImpt = document.getElementById(id)
      if (muniImpt !== null) {
        muniImpt.focus()
      }

      clearInterval(interval)
    }, loadTime)
  },

  chunkArray(myArray, n) {
    let tempArray = []
    let chunk_size = Math.ceil(Math.max(myArray.length / n, 1))
    for (let index = 0; index < myArray.length; index += chunk_size) {
      tempArray.push(myArray.slice(index, index + chunk_size))
    }
    return tempArray
  },
  irPara (path) {
    window.location = path
  },
  sortearPosicaoArray (array) {
    let sorteada = Math.floor(Math.random() * array.length)
    return array[sorteada]
  },
  reload (id) {
    let container = document.getElementById(id)
    container.click()
  },
  mudarFundo (id, cor) {
    let item = document.getElementById(id)
    item.style.backgroundColor = cor
  },

  mudarCorList (cor) {
    let listHover = document.getElementById('listHover')
    listHover.style.color = cor
  },
  toDataURL(url, callback) {
    var httpRequest = new XMLHttpRequest();
    httpRequest.onload = function() {
      var fileReader = new FileReader();
      fileReader.onloadend = function() {
        callback(fileReader.result);
      }
      fileReader.readAsDataURL(httpRequest.response);
    };
    httpRequest.open('GET', url);
    httpRequest.responseType = 'blob';
    httpRequest.send();
  }
}
